<div class="flex flex-col gap-4">
  <div>
    <div class="flex gap-1 items-center">
      <span class="text-sm font-semibold leading-6 line-clamp-1">
        {{ 'cockpit.supplierContracts.details.price.sidebar.annualConsumptionLabel' | transloco }}
      </span>
      <ui-help-button class="flex-none">
        <p slot="title" class="font-semibold">
          {{ 'help.annualConsumption.title' | transloco }}
        </p>
        <p class="text-sm">
          {{ 'help.annualConsumption.description' | transloco }}
        </p>
      </ui-help-button>
    </div>
    <ui-badge expand="full">
      <div class="flex justify-between gap-1 w-full">
        @if (supplierContract(); as contract) {
          <span class="tabular-nums">{{ totalConsumption() | germanNumber: 0 }}</span>
        } @else {
          <span></span>
        }
        <span>
          {{ 'cockpit.supplierContracts.units.referenceUnit.KWH' | transloco }}
        </span>
      </div>
    </ui-badge>
  </div>

  <div>
    <div class="flex gap-1 items-center">
      @if (view() === 'PRICE') {
        <span class="text-sm font-semibold leading-6 line-clamp-1">
          {{ 'cockpit.supplierContracts.details.price.sidebar.energyPrice' | transloco }}
        </span>
        <ui-help-button class="flex-none">
          <p slot="title" class="font-semibold">
            {{ 'help.energyPrice.title' | transloco }}
          </p>
          <p class="text-sm">
            {{ 'help.energyPrice.description' | transloco }}
          </p>
        </ui-help-button>
      } @else {
        <span class="text-sm font-semibold leading-6 line-clamp-1">
          {{ 'cockpit.supplierContracts.details.price.sidebar.energyCost' | transloco }}
        </span>
        <ui-help-button class="flex-none">
          <p slot="title" class="font-semibold">
            {{ 'help.energyCost.title' | transloco }}
          </p>
          <p class="text-sm">
            {{ 'help.energyCost.description' | transloco }}
          </p>
        </ui-help-button>
      }
    </div>
    <ui-badge expand="full">
      <div class="flex justify-between gap-1 w-full">
        @if (supplierContract(); as contract) {
          <span class="tabular-nums">
            @if (view() === 'PRICE') {
              {{ energyPrice() | priceRange: 'CENTS' : 2 }}
            } @else {
              {{ energyCost() | priceRange: 'EURO' : 2 }}
            }
          </span>
        } @else {
          <span></span>
        }
        <span>
          @if (view() === 'PRICE') {
            {{ 'cockpit.supplierContracts.units.currencyUnit.CENTS' | transloco }}/{{
              'cockpit.supplierContracts.units.referenceUnit.KWH' | transloco
            }}
          } @else {
            {{ 'cockpit.supplierContracts.units.currencyUnit.EURO' | transloco }}
          }
        </span>
      </div>
    </ui-badge>
  </div>

  <div class="flex items-center gap-2">
    <span
      class="text-sm font-normal leading-5 text-on-surface-variant dark:text-on-surface-variant-darkmode"
    >
      {{ 'cockpit.supplierContracts.details.price.sidebar.partialPricesConsumption' | transloco }}
    </span>
    <hr class="flex-1 border-outline dark:border-outline-darkmode" />
  </div>

  <div>
    <span class="text-sm font-semibold leading-6 line-clamp-1">
      {{ 'cockpit.supplierContracts.details.price.sidebar.energySupply' | transloco }}
    </span>
    <ui-badge expand="full">
      <div class="flex justify-between gap-1 w-full">
        @if (supplierContract(); as contract) {
          <span class="tabular-nums">
            @if (view() === 'PRICE') {
              {{ supplyPrice() | priceRange: 'CENTS' : 2 }}
            } @else {
              {{ supplyCost() | priceRange: 'EURO' : 2 }}
            }
          </span>
        } @else {
          <span></span>
        }
        <span>
          @if (view() === 'PRICE') {
            {{ 'cockpit.supplierContracts.units.currencyUnit.CENTS' | transloco }}/{{
              'cockpit.supplierContracts.units.referenceUnit.KWH' | transloco
            }}
          } @else {
            {{ 'cockpit.supplierContracts.units.currencyUnit.EURO' | transloco }}
          }
        </span>
      </div>
    </ui-badge>
  </div>

  <div>
    <span class="text-sm font-semibold leading-6 line-clamp-1">
      {{ 'cockpit.supplierContracts.details.price.sidebar.taxesAndDuties' | transloco }}
    </span>
    <ui-badge expand="full">
      <div class="flex justify-between gap-1 w-full">
        @if (supplierContract(); as contract) {
          <span class="tabular-nums">
            @if (view() === 'PRICE') {
              {{ taxesPrice() | priceRange: 'CENTS' : 2 }}
            } @else {
              {{ taxesCost() | priceRange: 'EURO' : 2 }}
            }
          </span>
        } @else {
          <span></span>
        }
        <span>
          @if (view() === 'PRICE') {
            {{ 'cockpit.supplierContracts.units.currencyUnit.CENTS' | transloco }}/{{
              'cockpit.supplierContracts.units.referenceUnit.KWH' | transloco
            }}
          } @else {
            {{ 'cockpit.supplierContracts.units.currencyUnit.EURO' | transloco }}
          }
        </span>
      </div>
    </ui-badge>
  </div>

  <div>
    <span class="text-sm font-semibold leading-6 line-clamp-1">
      {{ 'cockpit.supplierContracts.details.price.sidebar.gridCharges' | transloco }}
    </span>
    <ui-badge expand="full">
      <div class="flex justify-between gap-1 w-full">
        @if (supplierContract(); as contract) {
          <span class="tabular-nums">
            @if (view() === 'PRICE') {
              {{ gridPrice() | priceRange: 'CENTS' : 2 }}
            } @else {
              {{ gridCost() | priceRange: 'EURO' : 2 }}
            }
          </span>
        } @else {
          <span></span>
        }
        <span>
          @if (view() === 'PRICE') {
            {{ 'cockpit.supplierContracts.units.currencyUnit.CENTS' | transloco }}/{{
              'cockpit.supplierContracts.units.referenceUnit.KWH' | transloco
            }}
          } @else {
            {{ 'cockpit.supplierContracts.units.currencyUnit.EURO' | transloco }}
          }
        </span>
      </div>
    </ui-badge>
  </div>

  <div>
    <span class="text-sm font-semibold leading-6 line-clamp-1">
      {{ 'cockpit.supplierContracts.details.price.sidebar.metering' | transloco }}
    </span>
    <ui-badge expand="full">
      <div class="flex justify-between gap-1 w-full">
        @if (supplierContract(); as contract) {
          <span class="tabular-nums">
            @if (view() === 'PRICE') {
              {{ meteringPrice() | priceRange: 'CENTS' : 2 }}
            } @else {
              {{ meteringCost() | priceRange: 'EURO' : 2 }}
            }
          </span>
        } @else {
          <span></span>
        }
        <span>
          @if (view() === 'PRICE') {
            {{ 'cockpit.supplierContracts.units.currencyUnit.CENTS' | transloco }}/{{
              'cockpit.supplierContracts.units.referenceUnit.KWH' | transloco
            }}
          } @else {
            {{ 'cockpit.supplierContracts.units.currencyUnit.EURO' | transloco }}
          }
        </span>
      </div>
    </ui-badge>
  </div>
</div>
